import { render, staticRenderFns } from "./r-badge.vue?vue&type=template&id=4d2898b6&"
import script from "./r-badge.vue?vue&type=script&lang=js&"
export * from "./r-badge.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./r-badge.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports